import { Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { MainLayout } from './layouts/main-layout/main-layout';
import { AuthLayout } from '@layouts/auth-layout/auth-layout';
import { Error404Alt } from '@/app/views/error/error-404-alt';
import { MindmapEdit } from '@/app/views/mindmap/edit/mindmap-edit';
import { mindmapPermissionGuard } from '@/app/core/services/mindmap-permission.guard';
import { AuthorizeGuard } from '@/app/core/services/authorize.guard';
import { DeckTrain } from '@/app/views/deck/train/deck-train';

const PUBLIC_ID_PATTERN = /^[A-Za-z0-9]{26}$/;
const PUBLIC_SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

function publicMindMapUrlMatcher(
  segments: UrlSegment[],
): UrlMatchResult | null {
  if (
    segments.length !== 2 ||
    !PUBLIC_ID_PATTERN.test(segments[0].path) ||
    !PUBLIC_SLUG_PATTERN.test(segments[1].path)
  ) {
    return null;
  }

  return {
    consumed: segments,
    posParams: {
      publicId: segments[0],
      slug: segments[1],
    },
  };
}

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: 'viewer/:publicId/:slug',
    loadComponent: () =>
      import(
        './views/mindmap/public-mindmap-viewer/public-mindmap-viewer'
      ).then((mod) => mod.PublicMindmapViewer),
    data: { title: 'Shared Mind Map', framed: true },
  },
  {
    path: 'embed/:publicId/:slug',
    loadComponent: () =>
      import(
        './views/mindmap/public-mindmap-viewer/public-mindmap-viewer'
      ).then((mod) => mod.PublicMindmapViewer),
    data: { title: 'Mind map preview', embedded: true },
  },
  {
    path: 'share/:shareKey',
    loadComponent: () =>
      import(
        './views/mindmap/public-mindmap-viewer/public-mindmap-viewer'
      ).then((mod) => mod.PublicMindmapViewer),
    data: { title: 'Shared Mind Map' },
  },
  {
    matcher: publicMindMapUrlMatcher,
    loadComponent: () =>
      import(
        './views/mindmap/public-mindmap-viewer/public-mindmap-viewer'
      ).then((mod) => mod.PublicMindmapViewer),
    data: { title: 'Shared Mind Map' },
  },
  {
    path: 'mindmap-edit',
    component: MindmapEdit,
    canActivate: [AuthorizeGuard, mindmapPermissionGuard],
    data: { title: 'Mind Map' },
  },
  {
    path: 'deck/:deckId/train',
    component: DeckTrain,
    canActivate: [AuthorizeGuard],
    data: { title: 'Train Deck' },
  },
  {
    path: 'error/404-2',
    component: Error404Alt,
    data: { title: 'Error 404 Alt' },
  },
  {
    path: '',
    component: MainLayout,
    canActivateChild: [AuthorizeGuard],
    loadChildren: () =>
      import('./views/views.route').then((mod) => mod.VIEWS_ROUTES),
  },
  {
    path: '',
    component: AuthLayout,
    loadChildren: () =>
      import('./views/auth/auth.route').then((mod) => mod.AUTH_ROUTES),
  },
];
